var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#CDD9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.708 26.344V26.709C17.708 27.974 18.734 29 20 29V29C21.266 29 22.292 27.974 22.292 26.708V26.343",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 13.751V12.833C21.833 11.821 21.013 11 20 11V11C18.987 11 18.167 11.821 18.167 12.833V13.751",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.563 18.188V18.188C14.563 15.685 16.592 13.657 19.094 13.657H20.907C23.41 13.657 25.438 15.686 25.438 18.188V18.188V20.985C25.438 21.515 25.649 22.024 26.024 22.399L26.665 23.04C27.04 23.415 27.251 23.924 27.251 24.454V24.454C27.251 25.498 26.405 26.344 25.361 26.344H14.64C13.596 26.344 12.75 25.498 12.75 24.454V24.454C12.75 23.924 12.961 23.415 13.336 23.04L13.977 22.399C14.352 22.024 14.563 21.515 14.563 20.985V18.188Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyBellIcon);
export default __webpack_public_path__ + "static/media/grey-bell-icon.702084da25021f928ee3b9789ccfb1e1.svg";
export { ForwardRef as ReactComponent };